import { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { FaUserClock } from "react-icons/fa";
import { GiDuration } from "react-icons/gi";
import { PiStudentBold } from "react-icons/pi";
import { RiCalendarScheduleFill } from "react-icons/ri";
import { VscFeedback } from "react-icons/vsc";
import { motion } from "framer-motion";
import CoursesNavbar from "../components/CoursesNavbar";
import GetAdmissionForm from "../components/GetAdmissionForm";
import TrainingFooter from "../components/Tranining Footer";
import FAQSectionBusiness from "../components/FAQSectionBusiness";
import CertificateSection2 from "../components/CertificateSection2";
import EnrollNowButton from "../components/EnrollNowButton";
import BusinessCourseInstructors from "../components/BusinessCourseInstructors";
import Meta from "../components/Meta";


export default function BusinessCourses() {
  const [activeKey, setActiveKey] = useState("overview");
  const [modalSession, setModalSession] = useState(null);

  const courseFacts = [
    { icon: <PiStudentBold />, text: "Total Classes", value: "12+" },
    { icon: <FaUserClock />, text: "Time", value: "3:30 PM – 8:30 PM" },
    { icon: <GiDuration />, text: "Duration", value: "2 Hours+" },
    { icon: <RiCalendarScheduleFill />, text: "Days", value: "Friday & Saturday" },
    { icon: <VscFeedback />, text: "Fee", value: "৳14,500" },
  ];

  const courseSessions = [
  {
    title: "Class 1: Introduction to Business Setup & Regulatory Framework",
    topics: [
      "Understanding business consultancy and its importance",
      "Overview of legal frameworks in Bangladesh",
      "Key compliance authorities and their functions",
      "The role of consultants in business licensing and advisory"
    ]
  },
  {
    title: "Class 2: Company Registration with RJSC Procedures & Post-Registration Compliance",
    topics: [
      "Step-by-step process for company registration in Bangladesh",
      "Required documents and approvals",
      "RJSC (Registrar of Joint Stock Companies) procedures",
      "RJSC Return Filing procedures",
      "Reporting, compliance, and audit requirements",
      "Post-registration compliance and annual requirements"
    ]
  },
  {
    title: "Class 3: Foundation, NGO Registration Process & Compliance",
    topics: [
      "Types of foundations and NGOs in Bangladesh",
      "Legal process and authority approvals (Social Welfare, NGO Affairs Bureau)",
      "Reporting, compliance, and audit requirements",
      "Common challenges and best practices"
    ]
  },
  {
    title: "Class 4: Foreign/JV Company Registration Procedure in Bangladesh",
    topics: [
      "Foreign investment policies and legal framework",
      "Foreign/JV Company registration process and documentation",
      "Work permits and visa procedures for foreign nationals",
      "Reporting, compliance, and audit requirements",
      "Regulatory compliance for foreign branches and liaison offices"
    ]
  },
  {
    title: "Class 5: Factory ​Establishment Licenses with Different Authority",
    topics: [
      "Understanding business licenses and its importance",
      "Required documents and approvals",
      "Different Authority licenes, Import & Export, Indenting, Buying House license, Factory, Fire, Environment, BSTI, Premisies, DoT (Textile), ect. ",
      "Case studies on different authority licenses in Bangladesh"
    ]
  },
  {
    title: "Class 6: BIDA Procedures & Work Permits for Foreign National",
    topics: [
      "Overview of FDI system in Bangladesh",
      "Importance of intellectual property in business",
      "BIDA registration procedures and approval",
      "PI visa, work permit visa procedures and approval",
      "Penalties for non-compliance and how to avoid them"
    ]
  },
  {
    title: "Class 7: Intellectual Property Rights (IPR) for Businesses",
    topics: [
      "Importance of intellectual property in business",
      "Trademark, copyright, and patent registration process",
      "Protection against infringement and legal remedies",
      "Case studies on IP management in Bangladesh"
    ]
  },
  {
    title: "Class 8: TIN Registration and Tax Filing Compliance (Person/Business)",
    topics: [
      "Overview of taxation system in Bangladesh",
      "Income Tax, and Corporate Tax calculation",
      "Income Tax, and Corporate Tax compliance",
      "Regulatory filing procedures and deadlines",
      "Penalties for non-compliance and how to avoid them"
    ]
  },
  {
    title: "Class 9: BIN Registration and VAT Submission, Compliance",
    topics: [
      "Overview of vat system in Bangladesh",
      "BIN Registration and compliance",
      "VAT submission, compliance for manufacturing, trading, impoter",
      "Regulatory filing procedures and deadlines",
      "Penalties for non-compliance and how to avoid them"
    ]
  },
  {
    title: "Class 10: Startup funding Procedures",
    topics: [
      "Overview of startup finance / funding system in Bangladesh",
      "startup business registration in Bangladesh",
      "Compliance checklists for startup busines",
      "Q&A and career guidance session"
    ]
  },
  {
    title: "Special Class 11: Busines marketing strategy for startup",
    topics: [
      "Busines marketing strategy",
      "Marketing funnel with experienced consultants experts",
      "Marketing checklists for different types of businesses",
      "Q&A and career guidance session"
    ]
  },
  {
    title: "Special Class 12: Practical Case Studies & Industry Insights",
    topics: [
      "Real-life documentation and licensing examples",
      "Interaction with experienced consultants and legal experts",
      "Compliance checklists for different types of businesses",
      "Q&A and career guidance session"
    ]
  },
  {
    title: "Certification",
    topics: [
      "Upon successful completion of all modules and assignments, participants will receive a Joint Certificate from JK Associates & Chartered Skills, officially recognizing their expertise in Regulatory License and Compliance."
    ]
  }
];

<Meta title="Schedule X Return Filing in Bangladesh | RJSC Return Filing"
          description="Schedule X Return Filing in Bangladesh. A limited company required schedule X filled each financial year to the authority (RJSC)"
          keywords="Schedule X Return, Schedule X,  Schedule X in Bangladesh, RJSC Return Filing, company office return file, RJSC Return Filing in Bangladesh"
      />


  const openModal = (session) => setModalSession(session);
  const closeModal = () => setModalSession(null);

  const sessionVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <>
      <CoursesNavbar />
      <div style={{
        background: "linear-gradient(to right, #0066cc, #3399ff)",
        padding: "100px 20px",
        color: "#fff",
        textAlign: "center",
      }}>
        <h1 style={{ fontSize: "38px", fontWeight: "bold" }}>Certificate Course in Regulatory License and Compliance (CRLC)</h1>
        <p style={{ fontSize: "18px", marginTop: "10px" }}>
          Offered by JK Associates & Chartered Skills
        </p>
      </div>

      <div style={{
        backgroundColor: "#fff",
        maxWidth: "1000px",
        margin: "-80px auto 40px",
        borderRadius: "20px",
        padding: "40px 30px",
        boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
      }}>
        <h2 style={{ fontSize: "24px", marginBottom: "20px" }}>Course Overview</h2>
        <p style={{ fontSize: "16px", lineHeight: "1.7" }}>
          This certificate course is jointly organized by JK Associates and Chartered Skills. The training will be held on the premises of JK Associates.
        </p>

        <Tabs activeKey={activeKey} onSelect={(k) => setActiveKey(k || "overview")} style={{ marginTop: "30px" }}>
          <Tab eventKey="overview" title="Overview">
            <p style={{ marginTop: "20px", fontSize: "15px", lineHeight: "1.7" }}>
              The Certificate Course in Regulatory License and Compliance by JK Associates is designed
to develop practical expertise in business setup, licensing, and compliance procedures in
Bangladesh. This program provides participants with a clear understanding of how to legally
establish and manage companies, NGOs, and foreign entities while ensuring full regulatory
compliance.
Through interactive sessions led by experienced consultants and legal experts, learners gain
hands-on knowledge of BIDA registration, work permits, intellectual property rights, and
taxation requirements. The course blends theory with real-world applications, preparing
participants for careers in business consultancy, corporate compliance, or entrepreneurship.
Upon successful completion, participants receive a joint certificate from JK Associates &
Chartered Skills, validating their professional competency and enhancing their career
prospects in the corporate and consultancy sectors.
            </p>
          </Tab>

          <Tab eventKey="outline" title="Outline">
            <motion.div
              style={{ marginTop: "20px", display: "flex", flexWrap: "wrap", gap: "20px" }}
              initial="hidden"
              animate="visible"
              variants={{ visible: { transition: { staggerChildren: 0.1 } } }}
            >
              {courseSessions.map((session, idx) => (
                <motion.div
                  key={idx}
                  style={{
                    flex: "1 1 45%",
                    backgroundColor: "#3399ff",
                    color: "#fff",
                    borderRadius: "15px",
                    padding: "20px",
                    cursor: "pointer",
                    boxShadow: "0 6px 15px rgba(0,0,0,0.15)",
                    textAlign: "center"
                  }}
                  variants={sessionVariants}
                  whileHover={{ scale: 1.05 }}
                  onClick={() => openModal(session)}
                >
                  <h5 style={{ fontWeight: "600" }}>{session.title}</h5>
                  <p>Click to view details</p>
                </motion.div>
              ))}
            </motion.div>
          </Tab>
        </Tabs>
      </div>

      <div style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: "25px",
        padding: "30px 20px",
      }}>
        {courseFacts.map((item, i) => (
          <motion.div
            key={i}
            style={{
              backgroundColor: "#3399ff",
              color: "#fff",
              borderRadius: "15px",
              width: "200px",
              padding: "20px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              textAlign: "center",
            }}
            whileHover={{ scale: 1.05 }}
          >
            <div style={{ fontSize: "28px", marginBottom: "10px" }}>{item.icon}</div>
            <h4 style={{ fontSize: "16px" }}>{item.text}</h4>
            <p style={{ fontSize: "14px" }}>{item.value}</p>
          </motion.div>
        ))}
      </div>

      {modalSession && (
        <div style={{
          position: "fixed",
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: "rgba(0,0,0,0.6)",
          display: "flex", justifyContent: "center", alignItems: "center",
          zIndex: 9999
        }} onClick={closeModal}>
          <motion.div
            style={{
              backgroundColor: "#3399ff",
              color: "#fff",
              borderRadius: "15px",
              padding: "30px",
              maxWidth: "600px",
              width: "90%",
              maxHeight: "80%",
              overflowY: "auto"
            }}
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 100, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={{ marginBottom: "15px" }}>{modalSession.title}</h3>
            <ul style={{ paddingLeft: "20px" }}>
              {modalSession.topics.map((topic, idx) => (
                <li key={idx} style={{ marginBottom: "10px" }}>{topic}</li>
              ))}
            </ul>
            <button
              onClick={closeModal}
              style={{
                marginTop: "20px",
                padding: "10px 20px",
                backgroundColor: "#0066cc",
                border: "none",
                color: "#fff",
                borderRadius: "10px",
                cursor: "pointer"
              }}
            >
              Close
            </button>
          </motion.div>
        </div>
      )}
      <EnrollNowButton />
      <CertificateSection2 />
      <BusinessCourseInstructors/>
      <FAQSectionBusiness/>
      <GetAdmissionForm />
      <TrainingFooter />
    </>
  );
}
